import { render } from "./forbidden.vue?vue&type=template&id=a6c84bb4"
import script from "./forbidden.vue?vue&type=script&lang=js"
export * from "./forbidden.vue?vue&type=script&lang=js"

import "./forbidden.vue?vue&type=style&index=0&id=a6c84bb4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__